
export interface DirectDataInputEntity {
    id: number,
    masterType: string,
    opsDatetime: Date | null,
    forwarderCode: string,
    truckerName: string,
    cnicNo: string,
    vehicleNo: string,
    nature: string,
    damageType: string,
    remark: string,
    amount: number | null,
    status: string,
    currencyCode: string,
    serviceCode: string,
    specialHandleCodeList: string,
    operatingTml: string,


    [key: string]: string | number | Date | null | undefined
}

export const EMPTY_DIRECT_DATA_INPUT_ENTITY: DirectDataInputEntity = {
    id: 0,
    masterType: "",
    opsDatetime: null,
    forwarderCode: "",
    truckerName: "",
    cnicNo: "",
    vehicleNo: "",
    nature: "",
    damageType: "",
    remark: "",
    amount: null,
    status: "NEW",
    currencyCode: "",
    serviceCode: "",
    specialHandleCodeList: "",
    operatingTml: ""
}